
const StatusChangeModal = ({
  isOpen,
  onClose,
  onConfirm,
  franchisee,
  newStatus,
  isLoading
}) => {
  if (!isOpen || !franchisee) return null;

  const isActivating = newStatus === true;
  const actionText = isActivating ? 'Activate' : 'Suspend';
  const actionTextLower = isActivating ? 'activate' : 'suspend';

  const title = `${actionText} Franchisee`;
  const message = `Are you sure you want to ${actionTextLower} "${franchisee.franchiseName || franchisee.fseCode}"? ${
    isActivating
      ? 'This franchisee will be able to log in and access the system again.'
      : 'This franchisee will be immediately logged out and prevented from accessing the system.'
  }`;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex justify-center items-center">
      <div className="relative mx-auto p-5 border w-full max-w-md shadow-lg rounded-md bg-white">
        <div className="mt-3 text-center">
          <h3 className="text-lg leading-6 font-medium text-gray-900">{title}</h3>
          <div className="mt-2 px-7 py-3">
            <p className="text-sm text-gray-500">{message}</p>
          </div>
          <div className="items-center px-4 py-3 space-x-4 flex justify-center">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className={`px-4 py-2 text-white rounded transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center ${
                isActivating
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-red-600 hover:bg-red-700'
              }`}
            >
              {isLoading ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  {isActivating ? 'Activating...' : 'Suspending...'}
                </>
              ) : actionText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusChangeModal;
